// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__B9tzA","input":"Switch_input__tfRZQ","inner":"Switch_inner__0Dfl+","box":"Switch_box__OkRJC"};